import { useTheme } from "@mui/material/styles";
import { faResize } from "./helper.js";
import interact from "interactjs";
import { useRef, useEffect } from "react";
import useCurrentValue from "../../hooks/useCurrentValue.js";
import Helper from "../functions/Helper.js";

export default function DragLine({
  id = "",
  x1,
  x2,
  y1,
  y2,
  pixelPerFoot,
  edge = null,
  cursor = {
    type: "move",
    angle: 0,
    edge: "top",
  },
  className = "",
  onStart = () => {},
  onMove = () => {},
  onEnd = () => {},
}) {
  const theme = useTheme();
  let strokeColor = theme.palette.active;
  const dragLineRef = useRef();
  const pixelPerFootRef = useCurrentValue(pixelPerFoot);
  const dragDelta = useRef({ x: 0, y: 0 });

  useEffect(() => {
    let interactRef = dragLineRef.current;

    interact(interactRef)
      .styleCursor(false)
      .draggable({
        modifiers: [
          interact.modifiers.restrict({
            restriction: "#editor_wrapper",
          }),
        ],
        onstart: (event) => {
          onStart(event);
        },

        onend: (event) => {
          onEnd(dragDelta.current, event);
          dragDelta.current = { x: 0, y: 0 };
        },
        onmove: (event) => {
          var deltaX = event.dx / pixelPerFootRef.current;
          var deltaY = event.dy / pixelPerFootRef.current;
          dragDelta.current = {
            x: dragDelta.current.x + deltaX,
            y: dragDelta.current.y + deltaY,
          };
          onMove(dragDelta.current, event);
        },
      });

    return () => {
      interact(interactRef).unset();
    };
  }, []); //eslint-disable-line

  return (
    <>
      <line
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
        stroke={strokeColor}
        strokeWidth={2 / pixelPerFoot}
      />
      <line
        ref={dragLineRef}
        id={id}
        data-edge={edge}
        style={{
          cursor: faResize(cursor.angle + Helper.anglePerEdge[cursor.edge]),
        }}
        className={className}
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
        stroke="transparent"
        strokeWidth={15 / pixelPerFoot}
      />
    </>
  );
}
